import * as firebase from 'firebase-logic/firebase';
import { REACT_APP_TESTING_MODE } from '../config';

const getIdToken = async () => {
  const currentUser = firebase.auth.currentUser;
  if (!currentUser) {
    throw new Error('The current user is not authenticated');
  }

  return currentUser.getIdToken(true);
};

const authenticatedRequest = async (url: string, init: RequestInit = {}) => {
  const token = await getIdToken();
  const headers = new Headers(init.headers);
  headers.set('Authorization', `Bearer ${token}`);
  return fetch(url, {
    ...init,
    headers,
  });
};

export const StripeAPI = {
  createConnectedAccount: async (companyId: string) => {
    const url = REACT_APP_TESTING_MODE(companyId)
      ? 'https://europe-west3-droov-group-1.cloudfunctions.net/testStripeAccount/create-connected-account'
      : 'https://europe-west3-droov-group-1.cloudfunctions.net/stripeAccountEU/create-connected-account';
    return authenticatedRequest(url, {
      method: 'POST',
    });
  },
  createAccountLink: async (companyId: string) => {
    const body = new URLSearchParams();
    body.append(
      'refreshUrl',
      `${window.location.origin}/settings/payment?stripe=refresh`
    );
    body.append(
      'returnUrl',
      `${window.location.origin}/settings/payment?stripe=return`
    );
    const url = REACT_APP_TESTING_MODE(companyId)
      ? 'https://europe-west3-droov-group-1.cloudfunctions.net/testStripeAccount/create-account-link'
      : 'https://europe-west3-droov-group-1.cloudfunctions.net/stripeAccountEU/create-account-link';
    return authenticatedRequest(url, {
      method: 'POST',
      body,
    });
  },
  getAccountInformation: async (companyId: string) => {
    const url = REACT_APP_TESTING_MODE(companyId)
      ? 'https://europe-west3-droov-group-1.cloudfunctions.net/testStripeAccount/get-stripe-account'
      : 'https://europe-west3-droov-group-1.cloudfunctions.net/stripeAccountEU/get-stripe-account';
    return authenticatedRequest(url, {
      method: 'POST',
    });
  },
  verifyDomain: async (companyId: string) => {
    const url = REACT_APP_TESTING_MODE(companyId)
      ? 'https://europe-west3-droov-group-1.cloudfunctions.net/testStripeAccount/verify-domain'
      : 'https://europe-west3-droov-group-1.cloudfunctions.net/stripeAccountEU/verify-domain';
    return authenticatedRequest(url, {
      method: 'POST',
    });
  },
  /*getDomainList: () => {
    return firebase.auth.currentUser?.getIdToken(true).then((token) => {
      return fetch(
        'https://us-central1-droov-group-1.cloudfunctions.net/stripeAccount/my-apple-pay-domains',
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    });
  },
  addAppleDomain: () => {
    return firebase.auth.currentUser?.getIdToken(true).then((token) => {
      return fetch(
        'https://us-central1-droov-group-1.cloudfunctions.net/stripeAccount/add-apple-pay-domain',
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    });
  },*/
};
